import 'react-multi-carousel/lib/styles.css'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import AuthContext from 'store/auth-context'
import Image from 'next/image'
import cf from '@/lib/utils/common'
import parse from 'html-react-parser'
import styles from './index.module.css'
import { useRouter } from 'next/router'
import Link from '../../../../common/Link.js'
import { getStorage } from '../../../../common/lib/utils/localStorage'
import CustomLink from '@/components/Link'
import { getCookieTocken } from '@/commonComponents/login/userToken.js'
import { getProfileData } from '../../../lib/myProfile'
import static_config from '../../../../common/lib/utils/enum.json'
import commonFunction from '../../../../common/lib/utils/common'
import { getBalance } from '../../../../common/lib/login'
import dynamic from 'next/dynamic'
import { addDays, format } from 'date-fns'

const HotelSearchWidget = dynamic(() => import('../../common/hotel/widgets'))
const HolidaySearchWidget = dynamic(() => import('../../common/holiday/widgets'))
const Carousel = dynamic(() => import('react-multi-carousel').then((mod) => mod.default), { ssr: false })
const PromotionBanner = dynamic(() => import('../../promotionBanner/index'))
const BookingOverview = dynamic(() => import('../../PageBreakUp/hotel/BookingOverview'))
const BalaceSection = dynamic(() => import('../../PageBreakUp/homePage/BalanceSection'))
const BookAndEarn = dynamic(() => import('../../PageBreakUp/homePage/BookAndEarn'))
const QuickAction = dynamic(() => import('../../PageBreakUp/homePage/QuickAction'))
const RecentSearch = dynamic(() => import('../../PageBreakUp/hotel/RecentSearch'))
const VmsModalPopup = dynamic(() =>
  import('@/components/vms-components/ModalPopup').then((module) => module.VmsModalPopup)
)
const VmsInputRadioButton = dynamic(() =>
  import('@/components/vms-components/InputRadioButton').then(
    (module) => module.VmsInputRadioButton
  )
)
const FlightSearchWidget = dynamic(() => import('../../common/flight/widgets'))
const InsuranceSearchWidget = dynamic(() => import('../../common/insurance/widgets'))

let initRoom = static_config.roomConfig.defaultRoomsVal

export default function index(props) {
  const ctx = useContext(AuthContext)
  console.log("checking ctx in them10flow", ctx);

  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const wrapperRef = useRef(null)
  const [expandHotelNameBoolean, setExpandHotelName] = useState(false)
  const [getHotelAutoSuggestList, setHotelAutoSuggestList] = useState([])
  const [initHotelData, setInitHotelData] = useState([])
  const [homeBody, setHomeBody] = useState([])
  const [firstNobannerId, setFirstNoBannerId] = useState(null)
  const [lastNobannerId, setLastNoBannerId] = useState(null)
  const [hotelDefultDays, setHotelDefultDays] = useState(0)
  const [userProfile, setUserProfile] = useState('')
  const [searchWidget, setSearchWidget] = useState('')
  // const [SerachWidMob, setSerachWidMob] = useState('')
  const [isActive, setIsActive] = useState('')
  const [recentSearchData, setRecentSearchData] = useState([])
  const [isDesktopDefaultImg, setIsDesktopDefaultImg] = useState(false)
  const [isMobDefaultImg, setIsMobDefaultImg] = useState(false)
  const [section, setSection] = useState('home')
  const [profileData, setprofileData] = useState({})
  const [isProfileData, setIsProfileData] = useState(false)
  const [state, setState] = useState({
    showBreakfast: false,
    showFreeCancellation: false,
    recentSearchClicked: true,
    hotelName: '',
    getDestinationId: '',
    getSearchType: 6,
    property_count: '',
    dest_type: { code: '', text: '' },
  })
  const [showWidgets, setShowWidgets] = useState(false)
  const [showBalance, setShowBalance] = useState(false)
  const [currencyList, setCurrencyList] = useState([])
  const [currency, setCurrency] = useState('')
  const [availableBalance, setAvailableBalance] = useState({
    creditAmount: 0,
    balanceAmount: 0,
    usedAmount: 0,
  })
  const [isLoadingBalance, setIsLoadingBalance] = useState(false)
  const [flightSectorLength, setFlightSectorLength] = useState(1)
  const [balanceError, setBalanceError] = useState(false)
  const fullName = ctx?.user?.first_name + ' ' + ctx?.user?.last_name
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      // slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }

  const pathToWidgetMap = {
    '/hotel': 'hotel',
    '/hotels': 'hotel',
    '/holiday': 'holiday',
    '/holidays': 'holiday',
    '/flight': 'flight',
    '/flights': 'flight',
    '/insurance': 'insurance',
    '/insurances': 'insurance',
  }
  const isAdmin = ctx?.user?.user_type
  const cms = ctx?.user?.cms_services || {}

  useEffect(() => {
    getProfileDatafun()
    let userToken = cf.getCookieTocken('userToken')
    cf.getUserProfile(userToken, props.site_id).then((res) => {
      if (res.status === true) {
        setUserProfile(ctx?.user)
      } else {
        setUserProfile(res)
      }
    })
    updateHomeBody()
    if (props?.home?.data?.data?.body?.desktop) {
      /**FIND FIRST AVILLABLE WIDGET**/

      let defaultService = props.home.data.data.header.menu.filter(
        (ele) =>
          ele.status.toLowerCase() == 'active' &&
          cms[ele.code] &&
          cms[ele.code].status
      )
      if (defaultService.length > 0) {
        setSearchWidget(defaultService[0].code)
        setIsActive(defaultService[0].code)
      }

      let defaultImgDesktop = props.home.data.data.body.desktop.filter(
        (ele) => ele.type == 'image_carousal'
      )
      if (defaultImgDesktop.length == 0) {
        setIsDesktopDefaultImg(true)
      }

      let defaultImgMob =
        props?.home?.data?.data?.body?.mobile?.length > 0 &&
        props?.home?.data?.data?.body?.mobile.filter((ele) => ele.type == 'image_carousal')
      if (defaultImgMob.length == 0) {
        setIsMobDefaultImg(true)
      }

      let hotelIndex = props.home.data.data.body.desktop.findIndex(
        (items) => items.type === 'hotel_search'
      )
      if (hotelIndex > -1) {
        setHotelDefultDays(props.home.data.data.body.desktop[hotelIndex].default_days)
      }
    }

    const style = document.createElement('style')
    if (
      !cf.isValueEmpty(props) &&
      !cf.isValueEmpty(props.home) &&
      !cf.isValueEmpty(props.home.data)
    ) {
      style.innerHTML = props.home.data.data.css
      document.head.appendChild(style)
    }
    setActiveItemIndex(activeItemIndex)
    if (!cf.isValueEmpty(props) && !cf.isValueEmpty(props.home) && props.home.status === true) {
      if (
        !cf.isValueEmpty(props.home.data.data) &&
        !cf.isValueEmpty(props.home.data.data.body) &&
        !cf.isValueEmpty(props.home.data.data.body.desktop) &&
        props.home.data.data.body.desktop.length > 0
      ) {
        let hotelIndex = props.home.data.data.body.desktop.findIndex(
          (items) => items.type === 'hotel_search'
        )

        if (hotelIndex !== -1) {
          if (
            !cf.isValueEmpty(props.home.data.data.body.desktop[hotelIndex].locations) &&
            props.home.data.data.body.desktop[hotelIndex].locations.length > 0
          ) {
            setInitHotelData([...props.home.data.data.body.desktop[hotelIndex].locations])
            setHotelAutoSuggestList([...props.home.data.data.body.desktop[hotelIndex].locations])
          }
        }
      }
    }


    let LocalSearch = getStorage('hotelSearchKey')

    let LocalSearchAll = getStorage('hotelSearchKeyAll')

    if (LocalSearchAll != null) {
      setRecentSearchData(JSON.parse(LocalSearchAll))
    }
    if (LocalSearch != null && LocalSearchAll == null) {
      setRecentSearchData([JSON.parse(LocalSearch)])
    }

    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])

  useEffect(() => {
    if (recentSearchData && recentSearchData.length > 0) {
      recentSearchData.map((element, index) => {
        if (index == 0) {
          setState({
            showBreakfast: element?.is_breakfast,
            showFreeCancellation: element?.is_free_cancellation,
          })
        }
      })
    }
  }, [recentSearchData])

  useEffect(() => {
    try {
      updateHomeBody()

      const widget = pathToWidgetMap[window.location.pathname]

      if (widget) {
        setSearchWidget(widget)
        setIsActive(widget)
      }
    } catch (error) {
      console.log(error)
    }
  }, [query])

  function getProfileDatafun() {
    let data = {
      accessToken:
        getCookieTocken('userToken') !== undefined &&
          getCookieTocken('userToken') !== null &&
          getCookieTocken('userToken') !== ''
          ? getCookieTocken('userToken')
          : '',
      site_id: props.site_id || '',
    }
    getProfileData(data).then((res) => {
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setIsProfileData(true)
        let proData = res.data.data[0]
        setprofileData({ ...proData })
        // setIsLoader(false)
      }
    })
  }

  const updateHomeBody = () => {
    const homeBodyRes = props?.home?.data?.data?.body?.desktop // props?.isMobile ? props?.home?.data?.data?.body?.mobile : props?.home?.data?.data?.body?.desktop
    const firstNobanner = homeBodyRes?.find((item) => item.banner_data === 'nobanner')
    const lastNobanner = homeBodyRes?.filter((item) => item.banner_data === 'nobanner').pop()
    const firstNobannerOrder = firstNobanner ? firstNobanner?.order : null
    const lastNobannerOrder = lastNobanner ? lastNobanner?.order : null
    setHomeBody(homeBodyRes || [])
    setFirstNoBannerId(firstNobannerOrder)
    setLastNoBannerId(lastNobannerOrder)
    setCurrency(ctx?.user?.org_dtls?.default_currency)
    // const currencyData = [{ id: 0, label: ctx?.user?.org_dtls?.default_currency }]
    // if (ctx?.user?.org_dtls?.secondary_currency && ctx?.user?.org_dtls?.secondary_currency !== '') {
    //   currencyData.push({ id: 1, label: ctx?.user?.org_dtls?.secondary_currency })
    // }
    // setCurrencyList(currencyData)
    const currencies = ctx?.user?.org_dtls?.currencies

    console.log('currencies dsadadas', currencies)
    let currencyData = []

    if (currencies?.length > 0) {
      currencyData = currencies.map((item, index) => ({
        id: index,
        label: item?.currency,
        currency: item?.currency,
        type: item?.type,
      }))
    } else {
      currencyData = [
        {
          id: 0,
          label: ctx?.user?.org_dtls?.default_currency,
        },
      ]

      if (ctx?.user?.org_dtls?.secondary_currency) {
        currencyData.push({
          id: 1,
          label: ctx?.user?.org_dtls?.secondary_currency,
        })
      }
    }

    console.log('currencyData', currencyData)

    setCurrencyList(currencyData)
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (expandHotelNameBoolean === true) setExpandHotelName(false)
    }
  }

  const imageLoader = ({ src }) => {
    return `${'/shared/api/media/' + props.site_id + '/' + src}`
  }

  const router = useRouter()
  const query = router.query.index

  const copyCouponCode = (id) => {
    if (id) {
      var copyText = document.getElementById(id).innerHTML
      if (copyText) {
        navigator.clipboard.writeText(copyText)
        var copycouponcodeId = 'copycouponcode_' + id
        document.getElementById(copycouponcodeId).innerHTML = 'Copied'
        setTimeout(function () {
          document.getElementById(copycouponcodeId).innerHTML = 'Copy Code'
        }, 3000)
      }
    }
  }

  const renderIcon = (res) => {
    return <img src={`${'/shared/api/media/' + props.site_id + '/' + res.icon}`} alt={res.code} />
  }

  const renderTab = (res) => {
    const isActive =
      searchWidget === res.code || (searchWidget === 'holiday' && res.code === 'holidays')
    const tabClass = isActive ? styles.search_widget_tab_active : styles.search_widget_tab_inactive

    return (
      <li
        className={tabClass}
        onClick={() => {
          window.location.href = res.url
          //setSearchWidget(res.code === 'holidays' || res.code === 'holiday' ? 'holiday' : res.code)
        }}
      >
        <div className={styles.search_widget_icon}>{renderIcon(res)}</div>
        <span className={styles.search_widget_label}>{res.text}</span>
      </li>
    )
  }

  const renderWidgets = () => {
    return (
      <>
        {props.isMobile && (
          <div className={styles.search_widget_header}>
            <span
              className={styles.back_icon}
              onClick={() => {
                setShowWidgets(false)
                setSearchWidget('')
              }}
            >
              <svg
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 16.3516L0 8.35156L8 0.351562L9.42 1.77156L2.84 8.35156L9.42 14.9316L8 16.3516Z"
                  fill="#212121"
                />
              </svg>
            </span>
            <span className={styles.search_widget_title}>{searchWidget + 's'}</span>
          </div>
        )}
        {homeBody.map((res, i) => {
          return (
            <div key={'homeBodyDsktp' + i}>
              {searchWidget === 'hotel' && res.type == 'hotel_search' && (
                <div>
                  <HotelSearchWidget
                    theme={props?.home?.data?.site?.site_theme}
                    isMobile={props.isMobile}
                    checkinFormat={'dd MMM yyyy'}
                    checkoutFormat={'dd MMM yyyy'}
                    query={router.query}
                    cmsPopularData={[]}
                    currencyList={currencyList}
                    default_currency={ctx?.user?.org_dtls?.default_currency}
                    body={props?.home?.data?.data?.body}
                    home={props?.home?.data?.site}
                  />
                </div>
              )}
              {searchWidget === 'holiday' && res.type == 'holiday_search' && (
                <div>
                  <HolidaySearchWidget
                    theme={props?.home?.data?.site?.site_theme}
                    isMobile={props.isMobile}
                    checkinFormat={'dd MMM yyyy'}
                    checkoutFormat={'dd MMM yyyy'}
                    query={router.query}
                    cmsPopularData={[]}
                    currencyList={currencyList}
                    default_currency={ctx?.user?.org_dtls?.default_currency}
                    body={props?.home?.data?.data?.body}
                  />
                </div>
              )}
              {searchWidget === 'flight' && res.type == 'flight_search' && (
                <div>
                  <FlightSearchWidget
                    theme={props?.home?.data?.site?.site_theme}
                    isMobile={props.isMobile}
                    checkinFormat={'dd MMM yyyy'}
                    checkoutFormat={'dd MMM yyyy'}
                    query={router.query}
                    cmsPopularData={[]}
                    currencyList={currencyList}
                    default_currency={ctx?.user?.org_dtls?.default_currency}
                    body={props?.home?.data?.data?.body}
                    setFlightSectorLength={setFlightSectorLength}
                  />
                </div>
              )}
              {searchWidget === 'insurance' && res.type == 'insurance_search' && (
                <div>
                  <InsuranceSearchWidget
                    theme={props?.home?.data?.site?.site_theme}
                    isMobile={props.isMobile}
                    checkinFormat={'dd MMM yyyy'}
                    checkoutFormat={'dd MMM yyyy'}
                    query={router.query}
                    cmsPopularData={[]}
                    currencyList={currencyList}
                    default_currency={ctx?.user?.org_dtls?.default_currency}
                    body={props?.home?.data?.data?.body}
                  />
                </div>
              )}
            </div>
          )
        })}
      </>
    )
  }

  const redirectToSrp = (item) => {
    if (!item) return

    if (searchWidget === 'insurance') {
      const urlQuery = {
        currency: item.currency,
        org: item.sourceValue || '',
        dest: item.destinationValue,
        source: item.org,
        destination: item.destination,
        start_date: format(new Date(item.startDate), 'yyyy-MM-dd'),
        end_date: item.trip_type == 2 ? format(new Date(item.endDate), 'yyyy-MM-dd') : '',
        nationality: item.nationality ? item.nationality : '',
        travellers: encodeURIComponent(JSON.stringify(item.paxDetails)),
        guestId: item.guest_Id || '',
        trip_type: item.trip_type,
      }
      cf.redirectTo('/insurance/search', urlQuery)
    }

    const {
      search_text = '',
      checkin,
      checkout,
      rooms,
      destination_id = '',
      search_type = '',
      nationality = 'IN',
    } = item

    if (searchWidget === 'holiday') {
      const urlQuery = {
        searchby: item?.location,
        type: item?.searchType,
        category: '',
        currency: item?.currency,
        month: '',
      }

      cf.redirectTo('/holiday/search', urlQuery)
    } else if (searchWidget === 'hotel') {
      const hotelNameArray = search_text.split(',').map((str) => str.trim())
      const region = hotelNameArray[0] || ''
      const country = hotelNameArray[hotelNameArray.length - 1] || ''

      const checkInDate = checkin || addDays(new Date(), 1)
      const checkOutDate = checkout || addDays(new Date(), 2)

      const roomListArr = Array.isArray(rooms)
        ? rooms.map(({ adults, children }) => `${adults}a-${children}c`).join('_')
        : JSON.parse(JSON.stringify(initRoom))

      const urlQuery = {
        region,
        country,
        checkin: format(new Date(checkInDate), 'yyyy-MM-dd'),
        checkout: format(new Date(checkOutDate), 'yyyy-MM-dd'),
        rooms: roomListArr,
        type: 'location',
        roomtype: 'single',
        page: 1,
        orderby: 'desc',
        mop: 'accrual',
        destid: destination_id,
        search_type,
        ratings: '',
        bf: '',
        rf: '',
        nationality,
        is_web_app: false,
        hotelLocation: search_text,
        vid: destination_id,
        supplier: 'All',
        isModifySearch: false,
        currency: ctx?.user?.org_dtls?.default_currency || '',
        guestId: '',
      }

      cf.redirectTo('/hotel/search', urlQuery)
    } else if (searchWidget === 'flight') {
      const { search_url } = item
      cf.redirectTo('/flight/search', JSON.parse(search_url))
    }
  }

  const renderRecentAndBooking = () => {
    return (
      <Fragment>
        <div className={styles.hotel_widget_upcoming_bookings}>
          <RecentSearch
            theme={props?.home?.data?.site?.site_theme}
            props={props}
            additionalClassName={''}
            title={'Recent Searches'}
            dateFormat={'MMM DD YYYY'}
            showViewAll={false}
            upcomingVariant={false}
            profileData={profileData}
            isProfileData={isProfileData}
            product_type={searchWidget}
            isMobile={props.isMobile}
            onClick={redirectToSrp}
          />
        </div>

        <div className={styles.hotel_widget_upcoming_bookings}>
          <BookingOverview
            theme={props?.home?.data?.site?.site_theme}
            props={props}
            site_id={props.site_id}
            additionalClassName={''}
            title={'Upcoming Bookings'}
            dateFormat={'MMM DD YYYY'}
            showViewAll={true}
            upcomingVariant={true}
            profileData={profileData}
            isProfileData={isProfileData}
            product_type={searchWidget}
            isMobile={props.isMobile}
          />
        </div>
      </Fragment>
    )
  }

  const handleClick = () => {
    setShowBalance(!showBalance)
    getAvailableBalance()
  }

  const ModalHeader = () => {
    return (
      <div className={styles.check_balance_label}>
        <span className={styles.check_balance_label_text}>
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.33331 10.0007V10.6673V1.33398V10.0007ZM1.53848 11.6673C1.20604 11.6673 0.922035 11.5496 0.68648 11.3142C0.451035 11.0786 0.333313 10.7946 0.333313 10.4622V1.53915C0.333313 1.20671 0.451035 0.922707 0.68648 0.687151C0.922035 0.451707 1.20604 0.333984 1.53848 0.333984H10.4615C10.7939 0.333984 11.0779 0.451707 11.3135 0.687151C11.5489 0.922707 11.6666 1.20671 11.6666 1.53915V3.35332H10.6666V1.53915C10.6666 1.47926 10.6474 1.4301 10.609 1.39165C10.5705 1.35321 10.5214 1.33398 10.4615 1.33398H1.53848C1.47859 1.33398 1.42942 1.35321 1.39098 1.39165C1.35254 1.4301 1.33331 1.47926 1.33331 1.53915V10.4622C1.33331 10.522 1.35254 10.5712 1.39098 10.6096C1.42942 10.6481 1.47859 10.6673 1.53848 10.6673H10.4615C10.5214 10.6673 10.5705 10.6481 10.609 10.6096C10.6474 10.5712 10.6666 10.522 10.6666 10.4622V8.64798H11.6666V10.4622C11.6666 10.7946 11.5489 11.0786 11.3135 11.3142C11.0779 11.5496 10.7939 11.6673 10.4615 11.6673H1.53848ZM6.87181 9.00065C6.53937 9.00065 6.25537 8.88293 6.01981 8.64748C5.78437 8.41193 5.66665 8.12793 5.66665 7.79548V4.20582C5.66665 3.87337 5.78437 3.58937 6.01981 3.35382C6.25537 3.11837 6.53937 3.00065 6.87181 3.00065H11.1281C11.4606 3.00065 11.7446 3.11837 11.9801 3.35382C12.2156 3.58937 12.3333 3.87337 12.3333 4.20582V7.79548C12.3333 8.12793 12.2156 8.41193 11.9801 8.64748C11.7446 8.88293 11.4606 9.00065 11.1281 9.00065H6.87181ZM11.1281 8.00065C11.188 8.00065 11.2372 7.98143 11.2756 7.94298C11.3141 7.90454 11.3333 7.85537 11.3333 7.79548V4.20582C11.3333 4.14593 11.3141 4.09676 11.2756 4.05832C11.2372 4.01987 11.188 4.00065 11.1281 4.00065H6.87181C6.81192 4.00065 6.76276 4.01987 6.72431 4.05832C6.68587 4.09676 6.66665 4.14593 6.66665 4.20582V7.79548C6.66665 7.85537 6.68587 7.90454 6.72431 7.94298C6.76276 7.98143 6.81192 8.00065 6.87181 8.00065H11.1281ZM8.66665 7.00065C8.94442 7.00065 9.18054 6.90343 9.37498 6.70898C9.56942 6.51454 9.66665 6.27843 9.66665 6.00065C9.66665 5.72287 9.56942 5.48676 9.37498 5.29232C9.18054 5.09787 8.94442 5.00065 8.66665 5.00065C8.38887 5.00065 8.15276 5.09787 7.95831 5.29232C7.76387 5.48676 7.66665 5.72287 7.66665 6.00065C7.66665 6.27843 7.76387 6.51454 7.95831 6.70898C8.15276 6.90343 8.38887 7.00065 8.66665 7.00065Z"
              fill="white"
            />
          </svg>
          {'Check Balance'}
        </span>
        <span onClick={handleClick}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
              fill="white"
            />
          </svg>
        </span>
      </div>
    )
  }
  const handleCurrencySelect = (label) => {
    setCurrency(label)
  }

  useEffect(() => {
    if (currency) {
      getAvailableBalance()
    }
  }, [currency])

  useEffect(() => {
    const sectorId = document.getElementById('home_widget_container_multicity')
    if (sectorId && !props?.isMobile && flightSectorLength > 1) {
      sectorId.style.height = `${450 + 70 * (flightSectorLength - 1)}px`
    } else if (sectorId) {
      sectorId.style.removeProperty('height')
    }
  }, [flightSectorLength])

  const renderBalance = () => {
    return (
      <div className={styles.check_balance_container}>
        <VmsModalPopup
          additionalClassName={styles.mob_modal}
          isOpen={showBalance}
          isMobileView={false}
          closeButton={false}
          // modalHeaderCustomView={<ModalHeader />}
          overlayClassName={styles.ax_pax_modal_overlay}
        >
          {balaceData()}
        </VmsModalPopup>
      </div>
    )
  }

  const balaceData = () => {
    if (balanceError) {
      return (
        <div id="balance-modal" className={`${styles.check_balance} ${styles.check_balance_error}`}>
          <span onClick={handleClick} className={styles.error_close}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
                fill="black"
              />
            </svg>
          </span>
          <div className={styles.error_noresultfound} role="alert" aria-live="polite">
            <div className={styles.error_noresultfound__content}>
              <h2 className={styles.error_noresultfound__title}>
                We're experiencing a temporary issue retrieving your wallet balance.
              </h2>
              <p className={styles.error_noresultfound__subtitle}>Your funds are safe.</p>
              <button className={styles.error_noresultfound__button} onClick={getAvailableBalance}>
                Try Again
              </button>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles.check_balance}>
          <ModalHeader />
          <div className={styles.currency_selection}>
            {currencyList.map((item) => (
              <VmsInputRadioButton
                key={item.label}
                label={item.label}
                onChange={() => handleCurrencySelect(item.label)}
                value={item.label}
                id={item.id}
                checked={item.label === currency}
              />
            ))}
          </div>
          {isLoadingBalance ? (
            <>
              <div className={styles.credit_amount}>
                <div className={styles.skeleton_wrapper}>
                  <div className={styles.flex_rowjustify}>
                    <div className={styles.skeleton_text70}></div>
                    <div className={styles.skeleton_text30}></div>
                  </div>
                  <div className={styles.flex_rowjustify}>
                    <div className={styles.skeleton_text70}></div>
                    <div className={styles.skeleton_text30}></div>
                  </div>
                  <div className={styles.flex_rowjustify}>
                    <div className={styles.skeleton_text70}></div>
                    <div className={styles.skeleton_text30}></div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.credit_amount}>
                <span className={styles.credit_amount_label}>Credit Amount:</span>
                <span className={styles.credit_amount_value}>{commonFunction.useCommas(commonFunction.currencyAmountRounding(availableBalance.creditAmount, 2))}</span>
              </div>
              <div className={styles.balance_amount}>
                <span className={styles.credit_amount_label}>Balance Amount:</span>
                <span className={styles.credit_amount_value}>{commonFunction.useCommas(commonFunction.currencyAmountRounding(availableBalance.balanceAmount, 2))}</span>
              </div>
              <div className={styles.used_amount}>
                <span className={styles.credit_amount_label}>Used Amount:</span>
                <span className={styles.credit_amount_value}>{commonFunction.useCommas(commonFunction.currencyAmountRounding(availableBalance.usedAmount, 2))}</span>
              </div>
            </>
          )}
        </div>
      )
    }
  }

  const getAvailableBalance = async () => {
    setIsLoadingBalance(true)
    // setBalanceError(false)
    try {
      const response = await getBalance()
      if (response && response?.status === true) {
        let availableBalance = response || []
        setIsLoadingBalance(false)
        let creditAmount = 0
        let balanceAmount = 0
        let usedAmount = 0
        if (availableBalance && availableBalance?.data && Array.isArray(availableBalance?.data)) {
          const selectedCurrencyData = availableBalance?.data.find(
            (item) => item.credit_limit_summary?.currency === currency
          )

          if (selectedCurrencyData && selectedCurrencyData.credit_limit_summary) {
            creditAmount = selectedCurrencyData.credit_limit_summary.total_credit_limit || 0
            balanceAmount = selectedCurrencyData.credit_limit_summary.available_balance || 0
            usedAmount = selectedCurrencyData.credit_limit_summary.total_due_amount || 0
          } else {
            creditAmount = 0
            balanceAmount = 0
            usedAmount = 0
          }
          setAvailableBalance({
            creditAmount,
            balanceAmount,
            usedAmount,
          })
        }
      } else {
        setIsLoadingBalance(false)
        setBalanceError(true)
        console.error('Failed to fetch balance', response.message)
      }
    } catch (error) {
      setIsLoadingBalance(false)
      setBalanceError(true)

      console.error('Error fetching balance', error)
    }
  }

  return (
    <>
      {props.isMobile ? (
        <div
          className={`${styles.home_container} ${showWidgets ? styles.home_container_mobile : ''}`}
        >
          {showBalance && renderBalance()}
          {!showWidgets && (
            <h4
              className={styles.main__title}
            >{`Welcome, ${commonFunction.capitalizeEachWord(fullName)}`}</h4>
          )}
          {!showWidgets ? (
            <>
              <BalaceSection
                theme={props?.home?.data?.site?.site_theme}
                additionalClassName={''}
                title={'Upcoming Bookings'}
                dateFormat={'MMM DD YYYY'}
                handleClick={handleClick}
              />
              <BookAndEarn
                theme={props?.home?.data?.site?.site_theme}
                additionalClassName={''}
                title={'Upcoming Bookings'}
                dateFormat={'MMM DD YYYY'}
                menu={props?.home?.data?.data?.header?.menu?.filter(
                  (ele) => ele.status.toLowerCase() === 'active'
                )}
                site_id={props?.site_id}
                setSearchWidget={setSearchWidget}
                setShowWidgets={setShowWidgets}
              />
              <QuickAction
                theme={props?.home?.data?.site?.site_theme}
                additionalClassName={''}
                title={'Upcoming Bookings'}
                dateFormat={'MMM DD YYYY'}
                isAdmin={isAdmin}
              />
            </>
          ) : (
            <>
              <div className={styles.search_mobile_container}>{renderWidgets()}</div>
              <div className={styles.search_mobile_container_recent}>
                {renderRecentAndBooking()}
              </div>
            </>
          )}
        </div>
      ) : (
        <div className={styles.home_container}>
          <div className={`${styles.home_widget_container}`} id={'home_widget_container_multicity'}>
            <div style={{ margin: 0 }}>
              {homeBody.map((res, i) => {
                return (
                  <div key={'homeBodyDsktp' + i}>
                    {!cf.isValueEmpty(res.type) &&
                      res.type == 'image_carousal' &&
                      (res.banners && res.banners.length > 0 ? (
                        <div
                          className={`${props.isMobile ? styles.carousal_container : ''}`}
                          style={{ margin: 0 }}
                        >
                          <Carousel
                            swipeable={false}
                            draggable={false}
                            showDots={false}
                            responsive={responsive}
                            ssr={false} // means to render carousel on server-side.
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={3000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            containerClass={styles.carouse_container2}
                            //  containerClass="carousel-container"
                            // deviceType={this.props.deviceType}
                            dotListClass="custom-dot-list-style"
                            itemClass="carousel-item-padding-40-px"
                          >
                            {!cf.isValueEmpty(res) &&
                              !cf.isValueEmpty(res.banners) &&
                              res.banners.length > 0 &&
                              res.banners.map((imagedata, index) => {
                                return (
                                  <div
                                    style={{ margin: 0 }}
                                    key={'banner' + index}
                                    className={styles.img_banner_home2}
                                  >
                                    <CustomLink href={imagedata.banner_url}>
                                      <Image
                                        loader={imageLoader}
                                        src={
                                          props?.isMobile ? imagedata?.r_image : imagedata?.image
                                        }
                                        width={500}
                                        layout="fill"
                                        alt="image-carousel"
                                      />
                                    </CustomLink>
                                  </div>
                                )
                              })}
                          </Carousel>
                        </div>
                      ) : (
                        <div className={styles.nobanner}></div>
                      ))}
                  </div>
                )
              })}
            </div>

            <div className={styles.hero_section}>
              <h1 className={styles.hero_title}>Explore. Book. Earn.</h1>
              {/* <p className={styles.hero_subtitle}>Access 7,000+ hotels in 100+  </p> */}
              <p className={styles.hero_subtitle}>
                Search Smarter <span>&#124;</span> Book Faster
              </p>
            </div>

            <div
              className={`${styles.hotel_widget_container} 
            ${searchWidget == 'flight' ? styles.flight_widget_container : ''}
            ${searchWidget == 'insurance' ? styles.insurance_widget_container : ''}`}
            >
              <div
                className={`${styles.hotel_widget_parent} ${styles.hotel_widget_parent_container}`}
              >
                <div
                  className={`${styles.hotel_widget_wrap} ${searchWidget === 'hotel' ? styles.hotel_widget_search : styles.hotel_widget_home
                    }`}
                >
                  <div className={styles.search_widget_container}>
                    <div className={styles.search_widget}>
                      <div className={styles.search_widget_navbar_row}>
                        <div className={styles.search_widget_carousel_container}>
                          <nav className={styles.search_widget_navbar}>
                            <ul className={styles.search_widget_tabs}>
                              {props?.home?.data?.data?.header?.menu
                                .filter((ele) => ele.status.toLowerCase() === 'active')
                                .slice(0, 7)
                                .map((res) =>
                                  cms[res.code] && cms[res.code].status && res.code !== 'others' ? (
                                    <Link key={res.code} title={res.text} href={res.url}>
                                      {renderTab(res)}
                                    </Link>
                                  ) : cms[res.code] && cms[res.code].status ? (
                                    <a key={res.code} title={res.text} href={res.url}>
                                      <li
                                        className={
                                          searchWidget === 'others'
                                            ? styles.search_widget_tab_active
                                            : styles.search_widget_tab_inactive
                                        }
                                      >
                                        <div className={styles.search_widget_icon}>
                                          {res.icon === '' ? (
                                            <img src="images/forexImg.svg" alt={res.code} />
                                          ) : (
                                            <img
                                              src={`/shared/api/media/${props.site_id}/${res.icon}`}
                                              alt={res.code}
                                            />
                                          )}
                                        </div>
                                        {res.text}
                                      </li>
                                    </a>
                                  ) : (
                                    ''
                                  )
                                )}
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={styles.search_widget_body}>{renderWidgets()}</div>
                </div>
              </div>
            </div>
          </div>

          <Fragment>{renderRecentAndBooking()}</Fragment>

          {/* Recent Search Section end ==> */}

          <div>
            {homeBody.map((res, i) => {
              return (
                <div className={styles.promotion_banner} key={'homeBodyDsktp' + i}>
                  {res?.type == 'promotion_banner' ? (
                    <PromotionBanner
                      theme={props?.home?.data?.site?.site_theme}
                      isMobile={props?.isMobile}
                      responsive={responsive}
                      res={res}
                      imageLoader={imageLoader}
                      cssstyles={styles}
                      showIndicators={true && res?.banners?.length > 1}
                    />
                  ) : (
                    <div
                      className={
                        firstNobannerId == res.order
                          ? styles.firstnobanner
                          : res.order == lastNobannerId
                            ? styles.lastnobanner
                            : ''
                      }
                    >
                      {!cf.isValueEmpty(res.html)
                        ? parse(res.html, {
                          replace: ({ attribs }) => {
                            if (attribs && attribs.copycouponcode === 'copy') {
                              return (
                                <p
                                  class="copyZth"
                                  copycouponcode="copy"
                                  copycouponcodevalue={attribs.copycouponcodevalue}
                                  copycouponcodenumber={attribs.copycouponcodenumber}
                                  id={attribs.id}
                                  onClick={() => copyCouponCode(attribs.copycouponcodenumber)}
                                >
                                  Copy Code
                                </p>
                              )
                            }
                          },
                        })
                        : ''}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}
